import clsx from "clsx"
import React from "react"
import { IconProps } from "."

export default function MapPinFill({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M6.27249 16.8277L12.0001 22.5553L17.7277 16.8277C18.8605 15.6948 19.6319 14.2516 19.9445 12.6803C20.257 11.1091 20.0966 9.48044 19.4835 8.00036C18.8704 6.52029 17.8322 5.25525 16.5002 4.36521C15.1682 3.47518 13.6021 3.00012 12.0001 3.00012C10.3981 3.00012 8.83202 3.47518 7.49999 4.36521C6.16795 5.25525 5.12975 6.52029 4.51668 8.00036C3.90361 9.48044 3.74319 11.1091 4.05573 12.6803C4.36826 14.2516 5.1397 15.6948 6.27249 16.8277ZM12.0001 14.7001C11.0453 14.7001 10.1296 14.3208 9.45451 13.6456C8.77938 12.9705 8.40009 12.0548 8.40009 11.1001C8.40009 10.1453 8.77938 9.2296 9.45451 8.55447C10.1296 7.87934 11.0453 7.50005 12.0001 7.50005C12.9549 7.50005 13.8705 7.87934 14.5457 8.55447C15.2208 9.2296 15.6001 10.1453 15.6001 11.1001C15.6001 12.0548 15.2208 12.9705 14.5457 13.6456C13.8705 14.3208 12.9549 14.7001 12.0001 14.7001ZM12.0001 12.9001C12.4775 12.9001 12.9353 12.7104 13.2729 12.3728C13.6105 12.0353 13.8001 11.5774 13.8001 11.1001C13.8001 10.6227 13.6105 10.1648 13.2729 9.82726C12.9353 9.48969 12.4775 9.30005 12.0001 9.30005C11.5227 9.30005 11.0649 9.48969 10.7273 9.82726C10.3897 10.1648 10.2001 10.6227 10.2001 11.1001C10.2001 11.5774 10.3897 12.0353 10.7273 12.3728C11.0649 12.7104 11.5227 12.9001 12.0001 12.9001Z"
        fill="currentColor"
      />
    </svg>
  )
}
